import { render } from "./UserPermission.vue?vue&type=template&id=54b5916e&ts=true"
import script from "./UserPermission.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPermission.vue?vue&type=script&setup=true&lang=ts"

import "./UserPermission.vue?vue&type=style&index=0&id=54b5916e&lang=css"

import exportComponent from "/codebuild/output/src3693190966/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/userinfo/UserPermission.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54b5916e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54b5916e', __exports__)) {
    console.log('reload')
    api.reload('54b5916e', __exports__)
  }
  
  module.hot.accept("./UserPermission.vue?vue&type=template&id=54b5916e&ts=true", () => {
    console.log('re-render')
    api.rerender('54b5916e', render)
  })

}


export default __exports__